module.exports = __webpack_public_path__ + "static/logo-abc7774c6ef089e81e24fc54d3d2ed6e.webp";